<template lang="pug">
    footer
        .container
            p
                i.fa.fa-copyright
                |  {{ new Date().getFullYear() }} MAS Athena Reservations. All rights reserved.
            p v 1.0

</template>

<script>
    export default {
        name: 'Footer'
    };
</script>

<style lang="sass" scoped>
    @import "../assets/css/1-tools/font-awesome/font-awesome";
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"

    footer 
        background: #F8F9FB
        padding: 20px 0

        .container
            @extend %flex-center-between

            p 
                margin: 0
                color: $gray

                &:first-child
                    flex: 1

            @media (max-width: $device-xs)
                flex-direction: column

                p 
                    text-align: center

                    &:first-child
                        margin-bottom: 10px
</style>


